




















































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() itm!: any;

  @Prop() idx!: number;

  @Prop() addControlRule!: (...args: any[]) => any;

  @Prop() removeControlRule!: (...args: any[]) => any;

  @Prop() removeSwitchItem!: (...args: any[]) => any;
}
